module.exports = __webpack_public_path__ + "static/img/heavy-oil-residue_256.e486d0e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/heavy-oil-residue_256.png
// module id = QhtP
// module chunks = 0